exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width:992px){div.centered{max-height:100%;overflow-y:auto;width:100%;padding:50% 12.5%}}div.centered{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%)}div.bg{background-position:50%;background-repeat:no-repeat;background-attachment:fixed;background-size:cover;height:100vh;width:100vw;position:fixed}.vcenter{display:inline-block;vertical-align:middle;float:none}.online{color:#90ee90}.partial{color:#ffd800}.offline{color:#f44336}p{font-size:14px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?-url&minimize!./node_modules/sass-loader/lib/loader.js!./ClientApp/app/landingpage/landingpage.component.scss
// module id = 159
// module chunks = 6